// ISO 639
// currently supported languages
export enum LanguageCode {
  DE = 'de',
  EN = 'en',
}
